import { mutator } from 'satcheljs';
import { default as setModuleContextMailboxInfo } from '../actions/setModuleContextMailboxInfo';
import getModuleContextMailboxInfoStore from '../store/moduleContextMailboxInfoStore';

export default mutator(setModuleContextMailboxInfo, actionMessage => {
    const store = getModuleContextMailboxInfoStore();
    store.moduleContextMailboxInfo = actionMessage.mailboxInfo;
});
